import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import User from "../../APIController/User";
import Form from "../../Components/Form";
import Text from "../../Components/Text";
import TextInput from "../../Components/Form/TextInput";
import Button from "../../Components/Buttons/Button";
import Snackbar from "../../Components/Elements/Snackbar";

const ResetWithToken = () => {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const navigate = useNavigate();
  const { resetPassword } = User();
  const { token } = useParams();

  const handleLogin = () => {
    navigate("/login");
  };

  const handleSendReset = async (e) => {
    e.preventDefault();
    if (password !== passwordConfirm) {
      setSnackbarMessage("Passwörter stimmen nicht überein")
      return
    }

    const body = {
      password: password
    }

    const resettResponse = await resetPassword(body, token)
    if (resettResponse.ok) {
      setSnackbarMessage("Erfolgreich Resettet")
      navigate("/login");
    } else {
      const errorText = await resettResponse.text();
      setSnackbarMessage(`Reset fehlgeschlagen: ${errorText}`)
    }
  };

  return (
    <>
      <Form onSubmitAction={handleSendReset} submitButtonText={"Neues Passwort Speichern"} size="w-full" background="bg-white" border="">
        <Text type="maintitle" classNames={"flex text-center justify-center"}>Neues Passwort Setzen</Text>
        <TextInput placeholder={"Password"} value={password} action={(e) => setPassword(e.target.value)} type="password" />
        <TextInput placeholder={"Password Wiederholen"} value={passwordConfirm} action={(e) => setPasswordConfirm(e.target.value)} type="password" />
      </Form>
      <div className="flex flex-row items-center p-2">
        <Text type="buttontext">Lieber einloggen?</Text>
        <Button classNames="text-blue-500 hover:underline" buttonColor="transparent" borderStyle="" text={"Zur Anmelde Seite"} onClickAction={() => handleLogin()} />
      </div>
      <Snackbar message={snackbarMessage} onClose={() => setSnackbarMessage("")} />
    </>
  );
};

export default ResetWithToken;
